import { render } from "./FavoDoctors.vue?vue&type=template&id=41904d28"
import script from "./FavoDoctors.vue?vue&type=script&lang=js"
export * from "./FavoDoctors.vue?vue&type=script&lang=js"

import "./FavoDoctors.vue?vue&type=style&index=0&id=41904d28&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__